/* eslint-disable no-unused-expressions */
import { Stack } from '@mui/material';
import Typography from '@mui/material/Typography';
import { useState } from 'react';
import { UserInvitationExtendedDto } from 'tdc-web-backend/user-invitation/schemas';
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import useGetOne from '../../../utils/hooks/crud-hooks/useGetOne';
import LoadingIndicator from '../../../components/loading-indicator/LoadingIndicator';
import AcceptForm from './components/AcceptForm';

import InvalidToken from './components/InvalidToken';

const AcceptInvitation = () => {
  const { search } = useLocation();
  const queryParams = new URLSearchParams(search);
  const token = queryParams.get('token');
  const [isTokenValid, setIsTokenValid] = useState<boolean>(false);
  const { t } = useTranslation();
  const { data: invitatioData, isLoading: isGetDataLoading } = useGetOne<UserInvitationExtendedDto>(
    {
      resource: `user-invitation/by-token?token=${token}`,
      enabled: !!token,
      refetchOnMount: false,
      refetchOnReconnect: false,
      refetchOnWindowFocus: false,
      retry: false,
      onSuccess: (data) => {
        setIsTokenValid(true);
      },
      onError: () => {
        setIsTokenValid(false);
      },
    },
  );

  return (
    <Stack spacing={3} sx={{ pb: 4, minHeight: '90%' }}>
      <Typography
        variant="headline1"
        sx={{
          color: 'primaryDark.600',
        }}
      >
        {t('register.signUp')}
      </Typography>
      <>
        {token ? (
          isGetDataLoading ? (
            <LoadingIndicator />
          ) : isTokenValid && invitatioData ? (
            <AcceptForm invitationData={invitatioData.data} token={token} />
          ) : (
            <InvalidToken message={t('errors.invalidToken')} />
          )
        ) : (
          <InvalidToken message={t('errors.invalidToken')} />
        )}
      </>
    </Stack>
  );
};

export default AcceptInvitation;
